// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"35f079c8","504":"2592106b","633":"35f079c8","643":"087e1809","866":"35f079c8","977":"35f079c8"}[chunkId] + ".chunk.css";
};